// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c07f7116","977":"8e7f474d"}[chunkId] + ".chunk.js";
};